export { default } from "./FactorChart";
